import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { Colors } from '../../../../color/Colors';
export interface INestingButton {
  title: string;
  action: Function;
}

export const NestingButton = observer(({ title, action }: INestingButton) => {
  return (
    <Button
      onClick={() => action()}
      size="small"
      startIcon={<Add />}
      sx={{
        color: Colors.textPrimary,
        background: Colors.bgSurface,
        boxShadow: 'none',
        border: `1px solid ${Colors.border}`,
        borderRadius: '4px',
      }}
    >
      <Typography sx={{ fontSize: '12px' }}>{title}</Typography>
    </Button>
  );
});
